import { IstanzaSezioneDati } from '@framework/api-client';
import { YupAnyObjectSchema } from '@framework/validation';
import { useMemo } from 'react';
import { IEngineValidationContext } from '../../../engine/engine-validation/useEngineValidationContext';
import { getDeclarationsInitialValues } from '../../declarations/getDeclarationsInitialValues';

export interface IProcedureInitialValuesParams {
  allDeclarations: IstanzaSezioneDati[] | null | undefined;
  schema: YupAnyObjectSchema;
  validationContext: IEngineValidationContext | null | undefined;
}

/**
 * Hook per la gestione dei valori iniziali del procedimento
 * in `/procedures/list/:id`. I valori mostrati sono statici.
 */
export function useProcedureInitialValues(
  params: IProcedureInitialValuesParams,
) {
  const { allDeclarations, schema, validationContext } = params;

  const initialValues = useMemo(() => {
    if (!allDeclarations) {
      return schema.cast({}, { assert: false, context: validationContext });
    }

    const declarationValues = getDeclarationsInitialValues(
      allDeclarations,
      schema,
    );

    // TODO documenti e allegati initial values

    return schema.cast(declarationValues, {
      assert: false,
      context: validationContext,
    });
  }, [allDeclarations, schema, validationContext]);

  return initialValues;
}
